export async function openModalDriverDetails(button = null) {
    const modal = document.getElementById("modalOrderDriverDetails");
    const inner = document.getElementById("modalInnerDriver");

    if (!modal || !inner) return;

    // Ambil ID order dari tombol
    const driverOrderId = button?.getAttribute("data-id");
    if (!driverOrderId) return;

    // 🔹 Tampilkan modal dengan animasi
    modal.classList.remove("hidden");
    setTimeout(() => {
        modal.classList.add("opacity-100", "scale-100");
        inner.classList.add("opacity-100", "scale-100");
    }, 10);

    // 🔹 Reset tampilan lama
    const resetFields = [
        "uangSakuIn",
        "catatanIn",
        "uangSakuOut",
        "titipanUserOut",
        "catatanOut",
    ];
    resetFields.forEach((id) => {
        const el = document.getElementById(id);
        if (el) el.textContent = "-";
    });

    document.getElementById("filePreviewIn").innerHTML = "";
    document.getElementById("filePreviewOut").innerHTML = "";

    try {
        // 🔹 Ambil data dari server
        const response = await fetch("/admin/orderDriver/details", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-CSRF-TOKEN": document
                    .querySelector('meta[name="csrf-token"]')
                    .getAttribute("content"),
            },
            body: JSON.stringify({ driver_order_id: driverOrderId }),
        });

        const data = await response.json();
        if (!data.success) {
            alert("Gagal memuat data: " + (data.message || "Tidak diketahui"));
            return;
        }

        // === ISI DATA TEKS ===
        const inData = data.inData || {};
        const outData = data.outData || {};

        // 🔹 Data IN
        document.getElementById("titipanUserIn").textContent =
            inData.titipan_user != null ? Number(inData.titipan_user).toLocaleString("id-ID") : "-";
        document.getElementById("catatanIn").textContent = inData.catatan ?? "-";

        // 🔹 Data OUT
        document.getElementById("uangSakuOut").textContent =
            outData.uang_saku != null ? Number(outData.uang_saku).toLocaleString("id-ID") : "-";
        document.getElementById("catatanOut").textContent = outData.catatan ?? "-";

        // === CHECKLIST IN ===
        const checklistInContainer = document.getElementById("checklistIn");
        checklistInContainer.innerHTML = "";

        if (inData.checklist_items && inData.checklist_items.length > 0) {
            let htmlChecklistIn = `
                <div class="mb-4">
                    <h4 class="text-sm font-bold text-indigo-400 mb-2 flex items-center gap-2">
                        <i class="fa-solid fa-clipboard-check"></i> Checklist IN
                    </h4>
                    <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3">
            `;

            inData.checklist_items.forEach((item) => {
                const status =
                    item.value == 1
                        ? '<span class="text-green-400"><i class="fa-solid fa-check-circle"></i> OK</span>'
                        : '<span class="text-red-400"><i class="fa-solid fa-times-circle"></i> Tidak OK</span>';

                htmlChecklistIn += `
                    <div class="p-3 rounded-lg bg-gray-800 border border-gray-700">
                        <p class="text-sm font-semibold text-gray-100">${item.nama_item}</p>
                        <p class="mt-1 text-xs">${status}</p>
                    </div>
                `;
            });

            htmlChecklistIn += `</div></div>`;
            checklistInContainer.innerHTML = htmlChecklistIn;
        } else {
            checklistInContainer.innerHTML = `<p class="text-gray-500 text-xs italic mb-4">Tidak ada data checklist IN.</p>`;
        }

        // === CHECKLIST OUT ===
        const checklistOutContainer = document.getElementById("checklistOut");
        checklistOutContainer.innerHTML = "";

        if (outData.checklist_items && outData.checklist_items.length > 0) {
            let htmlChecklistOut = `
                <div class="mb-4">
                    <h4 class="text-sm font-bold text-red-400 mb-2 flex items-center gap-2">
                        <i class="fa-solid fa-clipboard-check"></i> Checklist OUT
                    </h4>
                    <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3">
            `;

            outData.checklist_items.forEach((item) => {
                const status =
                    item.value == 1
                        ? '<span class="text-green-400"><i class="fa-solid fa-check-circle"></i> OK</span>'
                        : '<span class="text-red-400"><i class="fa-solid fa-times-circle"></i> Tidak OK</span>';

                htmlChecklistOut += `
                    <div class="p-3 rounded-lg bg-gray-800 border border-gray-700">
                        <p class="text-sm font-semibold text-gray-100">${item.nama_item}</p>                
                        <p class="mt-1 text-xs">${status}</p>
                    </div>
                `;
            });

            htmlChecklistOut += `</div></div>`;
            checklistOutContainer.innerHTML = htmlChecklistOut;
        } else {
            checklistOutContainer.innerHTML = `<p class="text-gray-500 text-xs italic mb-4">Tidak ada data checklist OUT.</p>`;
        }

        // === FILE PREVIEW IN (GROUPING PER CATEGORY, sama seperti OUT) ===
        const filePreviewIn = document.getElementById("filePreviewIn");
        filePreviewIn.innerHTML = "";

        if (inData.files && inData.files.length > 0) {
            const groupedIn = {};
            inData.files.forEach((file) => {
                const category = file.category || "Lainnya";
                if (!groupedIn[category]) groupedIn[category] = [];
                groupedIn[category].push(file);
            });

            let htmlIn = `<div class="flex flex-col gap-6 w-full">`;

            for (const [category, files] of Object.entries(groupedIn)) {
                let displayCategory =
                    category === "range_bbm" ? "Range BBM" :
                    category === "spedo" ? "Spedo" :
                    category === "bbm" ? "BBM" :
                    capitalizeFirstLetter(category);
                htmlIn += `
                <div class="w-full">
                    <h5 class="text-sm font-semibold text-indigo-400 mb-2 border-b border-gray-700 pb-1 flex items-center gap-2">
                        <i class="fa-solid fa-folder-open text-indigo-400"></i> ${displayCategory}
                    </h5>

                    <!-- File sejajar dalam grid -->
                    <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 w-full">
                `;

                files.forEach((file) => {
                    const fileUrl = file.file_url || file.file_path || "";
                    const categoryLower = (file.category || "").toLowerCase();

                    let fileLabel = "-";
                    if (categoryLower === "bbm") {
                        fileLabel = inData.bbm ?? "-";
                    } else if (categoryLower === "spedo") {
                        fileLabel = inData.spedo_akhir ?? "-";
                    } else if (categoryLower === "range_bbm") {
                        fileLabel = inData.range_bbm ?? "-";
                    } else {
                        fileLabel = file.label ?? "-";
                    }

                    htmlIn += `
                        <div class="border border-gray-700 rounded-xl overflow-hidden shadow bg-gray-800 hover:bg-gray-750 transition">
                            <img 
                                src="${fileUrl}" 
                                alt="${fileLabel}" 
                                class="block w-full max-h-64 object-contain bg-black cursor-pointer hover:opacity-90 transition"
                                onclick="window.previewImage('${fileUrl}')"
                            >
                            <p class="text-xs text-gray-300 text-center mt-1 italic p-1 bg-gray-900">${fileLabel}</p>
                        </div>
                    `;
                });
                htmlIn += `</div></div>`;
            }

            htmlIn += `</div>`;
            filePreviewIn.innerHTML = htmlIn;
        } else {
            filePreviewIn.innerHTML = `<p class="text-gray-500 text-xs italic">Tidak ada dokumen IN.</p>`;
        }

        // === FILE PREVIEW OUT ===
        const filePreviewOut = document.getElementById("filePreviewOut");
        filePreviewOut.innerHTML = "";

        if (outData.files && outData.files.length > 0) {
            const groupedOut = {};
            outData.files.forEach((file) => {
                const category = file.category || "Lainnya";
                if (!groupedOut[category]) groupedOut[category] = [];
                groupedOut[category].push(file);
            });

            let htmlOut = `<div class="flex flex-col gap-6 w-full">`;

            for (const [category, files] of Object.entries(groupedOut)) {
                let displayCategory =
                    category === "bbm" ? "Range BBM" :
                    category === "spedo" ? "Spedo" :
                    capitalizeFirstLetter(category);

                htmlOut += `
                    <div class="w-full">
                        <h5 class="text-sm font-semibold text-red-400 mb-2 border-b border-gray-700 pb-1 flex items-center gap-2">
                            <i class="fa-solid fa-folder-open text-red-400"></i> ${displayCategory}
                        </h5>

                        <!-- File sejajar dalam grid -->
                        <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 w-full">
                `;

                files.forEach((file) => {
                    const fileUrl = file.file_url || file.file_path || "";
                    const categoryLower = (file.category || "").toLowerCase();

                    let fileLabel = "-";
                    if (categoryLower === "bbm") {
                        fileLabel = outData.range_bbm ?? "-";
                    } else if (categoryLower === "spedo") {
                        fileLabel = outData.spedo_akhir ?? "-";
                    } else {
                        fileLabel = file.label ?? "-";
                    }

                    htmlOut += `
                        <div class="border border-gray-700 rounded-xl overflow-hidden shadow bg-gray-800 hover:bg-gray-750 transition">
                            <img 
                                src="${fileUrl}" 
                                alt="${fileLabel}" 
                                class="block w-full max-h-64 object-contain bg-black cursor-pointer hover:opacity-90 transition"
                                onclick="window.previewImage('${fileUrl}')"
                            >
                            <p class="text-xs text-gray-300 text-center mt-1 italic p-1 bg-gray-900">${fileLabel}</p>
                        </div>
                    `;
                });
                htmlOut += `</div></div>`;
            }

            htmlOut += `</div>`;
            filePreviewOut.innerHTML = htmlOut;
        } else {
            filePreviewOut.innerHTML = `<p class="text-gray-500 text-xs italic">Tidak ada dokumen OUT.</p>`;
        }
    } catch (err) {
        console.error("Error:", err);
        alert("Terjadi kesalahan saat memuat data.");
    }
}

export function previewImage(src) {
    console.log("Preview modal muncul untuk:", src);

    const modal = document.createElement("div");
    modal.className = `
        fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-[9999]
    `;
    modal.innerHTML = `
        <div class="relative">
            <img src="${src}" class="max-h-[90vh] max-w-[90vw] rounded-lg shadow-lg" />
            <button class="absolute top-2 right-2 text-white bg-black/50 rounded-full p-2 hover:bg-black/70"
                onclick="this.parentElement.parentElement.remove()">
                <i class="fa-solid fa-xmark text-lg"></i>
            </button>
        </div>
    `;
    document.body.appendChild(modal);
}

function capitalizeFirstLetter(str) {
    if (!str) return "";
    return str.charAt(0).toUpperCase() + str.slice(1);
}

// Biar fungsi bisa dipanggil dari HTML onclick
window.previewImage = previewImage;

// 🔹 Tutup modal
export function closeModalDriverDetails() {
    const modal = document.getElementById("modalOrderDriverDetails");
    const inner = document.getElementById("modalInnerDriver");

    if (!modal || !inner) return;

    modal.classList.remove("opacity-100", "scale-100");
    inner.classList.remove("opacity-100", "scale-100");

    setTimeout(() => {
        modal.classList.add("hidden");
    }, 200);
}

export async function markDriverOrderCompleted(button) {
    const orderId = button.getAttribute("data-id");
    if (!orderId) return;

    const result = await Swal.fire({
        title: "Yakin?",
        text: "Ingin menandai order ini sebagai completed?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Ya, selesaikan!",
        cancelButtonText: "Batal"
    });

    if (!result.isConfirmed) return;

    try {
        const response = await fetch(`/admin/orderDriver/${orderId}/complete`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-CSRF-TOKEN": document.querySelector('meta[name="csrf-token"]').getAttribute("content")
            }
        });

        const data = await response.json();

        if (data.success) {
            Swal.fire({
                title: "Berhasil!",
                text: "Order berhasil diset completed.",
                icon: "success",
                timer: 1500,
                showConfirmButton: false,
                willClose: () => location.reload()
            });
        } else {
            Swal.fire({
                title: "Gagal!",
                text: data.message || "Terjadi kesalahan",
                icon: "error",
                timer: 1500,
                showConfirmButton: false
            });
        }
    } catch (err) {
        console.error(err);
        Swal.fire({
            title: "Error!",
            text: "Terjadi kesalahan saat memproses order.",
            icon: "error",
            timer: 1500,
            showConfirmButton: false
        });
    }
}

export async function markDriverOrderRejected(button) {
    const orderId = button.getAttribute("data-id");
    if (!orderId) return;

    // SweetAlert2 confirm sebelum reject
    const result = await Swal.fire({
        title: "Konfirmasi",
        text: "Yakin ingin menandai order ini sebagai rejected?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Ya, reject!",
        cancelButtonText: "Batal",
    });

    if (!result.isConfirmed) return;

    try {
        const response = await fetch(`/admin/orderDriver/${orderId}/reject`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-CSRF-TOKEN": document.querySelector('meta[name="csrf-token"]').getAttribute("content")
            }
        });

        const data = await response.json();

        if (data.success) {
            Swal.fire({
                title: "Berhasil!",
                text: "Order berhasil diset rejected.",
                icon: "success",
                timer: 1500,
                showConfirmButton: false,
                willClose: () => location.reload()
            });
        } else {
            Swal.fire({
                title: "Gagal!",
                text: data.message || "Terjadi kesalahan",
                icon: "error",
                timer: 1500,
                showConfirmButton: false
            });
        }
    } catch (err) {
        console.error(err);
        Swal.fire({
            title: "Error!",
            text: "Terjadi kesalahan saat memproses order.",
            icon: "error",
            timer: 1500,
            showConfirmButton: false
        });
    }
}

window.markDriverOrderCompleted = markDriverOrderCompleted;
window.markDriverOrderRejected = markDriverOrderRejected;